import { normalize } from './normalize';

export const getDisplayValue = (element: Element): string => {
  const values: string[] = [];

  element.querySelectorAll('[class*="-singleValue"]').forEach((el) => {
    const text = (el as HTMLElement).textContent?.trim() || '';
    if (text) values.push(text);
  });

  element.querySelectorAll('.dropdown-heading-value').forEach((el) => {
    const text = (el as HTMLElement).textContent?.trim() || '';
    if (text) values.push(text);
  });

  return values.join('|');
};

export const checkForExpectedText = (element: Element, expectedValue: string, onMatch: () => void) => {
  const displayValue = getDisplayValue(element);

  if (displayValue) {
    const normalizedExpected = normalize(expectedValue);
    if (normalize(displayValue).includes(normalizedExpected)) {
      onMatch();
    }
  }
};
